export default "__VITE_ASSET__CMhYdfgN__"